/*
 * Sidebar product search on the collection page.
 *
 * Types -> debounced fetch of the search results page -> the product grid is swapped in place.
 * No dropdown, no autosuggest, no page reload. Clearing the box puts the original collection
 * grid back.
 *
 * Listeners are bound to `document` because the theme's filter AJAX replaces the whole
 * #shopify-section-* innerHTML, which would throw away anything bound to the elements directly.
 */
(function () {
  'use strict';

  var MIN_CHARS = 2;
  var DEBOUNCE_MS = 350;

  var timer = null;
  var inFlight = null;         // AbortController for the pending request
  var cachedGrid = null;       // the collection's own grid, restored when the box is cleared
  var lastTerm = '';

  function gridEl() {
    return (
      document.querySelector('.collection-wrapper .l4cl:not(.bls)') ||
      document.querySelector('#main-collection .l4cl:not(.bls)') ||
      document.querySelector('.l4cl:not(.bls)')
    );
  }

  function statusEl(create) {
    var existing = document.querySelector('.f8fl-search-status');
    if (existing || !create) return existing;

    var grid = gridEl();
    if (!grid) return null;

    var p = document.createElement('p');
    p.className = 'f8fl-search-status';
    p.setAttribute('role', 'status');
    p.setAttribute('aria-live', 'polite');
    grid.parentNode.insertBefore(p, grid);
    return p;
  }

  function setStatus(message) {
    var el = statusEl(!!message);
    if (!el) return;
    if (!message) {
      el.parentNode.removeChild(el);
      return;
    }
    el.textContent = message;
  }

  function restoreGrid() {
    var grid = gridEl();
    if (grid && cachedGrid !== null) {
      grid.innerHTML = cachedGrid;
    }
    setStatus('');
    lastTerm = '';
  }

  function runSearch(term, input) {
    var grid = gridEl();
    if (!grid) return;

    // remember the untouched collection grid so clearing the box can put it back
    if (cachedGrid === null) cachedGrid = grid.innerHTML;

    if (inFlight) inFlight.abort();
    inFlight = new AbortController();

    grid.classList.add('processing');
    setStatus(input.dataset.searchingText || 'Searching...');

    // data-search-url comes from Liquid's routes.search_url, so locale-prefixed
    // storefronts (/fr/search) keep working. window.routes has no search_url.
    var base = input.dataset.searchUrl || '/search';
    var url = base + '?type=product&q=' + encodeURIComponent(term);

    fetch(url, { signal: inFlight.signal })
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var results = doc.querySelector('.l4cl:not(.bls)');
        var target = gridEl();
        if (!target) return;

        grid.classList.remove('processing');

        if (!results || !results.querySelector('li')) {
          target.innerHTML = '';
          setStatus(
            (input.dataset.noResultsText || 'No products found for') + ' “' + term + '”'
          );
          return;
        }

        target.innerHTML = results.innerHTML;

        var count = results.querySelectorAll('li').length;
        setStatus(
          count + ' ' + (input.dataset.resultsText || 'results for') + ' “' + term + '”'
        );

        // let the theme re-initialise anything inside the newly injected cards
        if (typeof window.dispatchEvent === 'function') {
          ['listProductSlider', 'ratings', 'lazyImages'].forEach(function (name) {
            try {
              window.dispatchEvent(new CustomEvent(name));
            } catch (e) {
              /* the theme may not define every one of these */
            }
          });
        }
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return; // superseded by a newer keystroke
        grid.classList.remove('processing');
        setStatus(input.dataset.errorText || 'Search is unavailable right now.');
      });
  }

  function handle(input, immediate) {
    var term = (input.value || '').trim();
    if (term === lastTerm && !immediate) return;

    clearTimeout(timer);

    if (term.length < MIN_CHARS) {
      if (inFlight) inFlight.abort();
      restoreGrid();
      return;
    }

    lastTerm = term;
    timer = setTimeout(function () {
      runSearch(term, input);
    }, immediate ? 0 : DEBOUNCE_MS);
  }

  // The input is intentionally not inside a form and has no name attribute, so that
  // third-party search apps do not attach their autosuggest dropdown to it.
  function sidebarInput(node) {
    return node && node.closest ? node.closest('.f8fl-search .f8fl-search-input') : null;
  }

  document.addEventListener('input', function (e) {
    var input = sidebarInput(e.target);
    if (!input) return;
    handle(input, false);
  });

  // No form to submit, so Enter is handled here
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = sidebarInput(e.target);
    if (!input) return;
    e.preventDefault();
    handle(input, true);
  });
})();
